module.exports = __webpack_public_path__ + "img/pad.daf912da.svg";